import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { navigate, useStaticQuery, graphql } from 'gatsby';
import axios from 'axios';
import Icon from '../Icon';

function SearchForm(props) {
  const { value } = props;
  const [name, setName] = useState(value);

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            freshDesk {
              apiUrl,
              apiUser
            }
          }
        }
      }
    `
  );
  
  const handleSubmit = (evt) => {
    evt.preventDefault();
    navigate(`/help/search?term=${name}`, { state: { searchKey: name } });
    const searchApi = `${site.siteMetadata.freshDesk.apiUrl}/search/solutions?term=${name}`;
    axios.get(searchApi, {
      auth: {
        username: site.siteMetadata.freshDesk.apiUser,
        password: 'x'
      }
    }).then((response) => {
      const url = `/help/search?term=${name}`;
      navigate(url, { state: { data: response.data, searchKey: name }, hash: name, replace: true });
    });
  };
  return (
    <form onSubmit={handleSubmit}>
      <div className="search-icon">
        <Icon name="search" color="#595959" />
      </div>
      <div className="blue-circle">
        <Icon name="blueCircle" color="#5986FF" />
      </div>
      <input
        type="text"
        value={name}
        placeholder="Search for help on specific topics"
        onChange={e => setName(e.target.value)}
        required
      />
      <input type="submit" value="Submit" style={{ display: 'none' }} />
    </form>
  );
}

export default SearchForm;

SearchForm.propTypes = {
  value: PropTypes.string.isRequired,
};
